export default "__VITE_ASSET__DZ4xRYJx__"